import { Component, OnInit, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { LockGroupDetailsUIModel } from '../../models/LockGroupDetailsUIModel';
import { PermissionDetailsV2, PermissionsService } from '../../lockvue-ng-sdk';
import { BaseConfirmationWithPermissionsComponent } from '../base-confirmation-with-permissions/base-confirmation-with-permissions.component';

@Component({
  selector: 'lockvue-remove-group-confirmation',
  templateUrl: './remove-group-confirmation.component.html',
  styleUrls: ['./remove-group-confirmation.component.scss'],
})
export class RemoveGroupConfirmationComponent extends BaseConfirmationWithPermissionsComponent {
  @Input() group: LockGroupDetailsUIModel;
  @Input() permissions: PermissionDetailsV2[];
  @Input() revokePermissions: boolean = true;

  constructor(ref: NbDialogRef<ConfirmDialogComponent>, permissionsService: PermissionsService) {
    super(ref, permissionsService);
  }

  submit() {
    super.submit(this.revokePermissions, this.permissions);
  }
}
